@if (visible) {
<div class="gestimmo-banner">
  <a
    class="gestimmo-banner-link"
    href="https://www.gestimmo.swiss"
    target="_blank"
    rel="noopener"
    aria-label="Vous travaillez dans une commune ? Découvrez GestImmo"
    (click)="openInfo($event)"
  >
    <em class="fal fa-sparkles"></em>
    Découvrez GestImmo
  </a>
  <button
    type="button"
    class="gestimmo-banner-close"
    (click)="requestDismiss()"
    aria-label="Masquer le bouton GestImmo"
  >
    <em class="fal fa-times"></em>
  </button>
</div>
}

@if (showingInfo) {
<div class="gestimmo-info-backdrop" (click)="closeInfo()">
  <div class="gestimmo-info-modal" (click)="$event.stopPropagation()">
    <p>
      <strong>Vous travaillez dans une commune ?</strong> GestImmo est
      développé par la même équipe que Mir, avec la même philosophie :
      simplifier le travail au quotidien. Il permet de gérer
      les infrastructures, bâtiments, espaces verts, véhicules, machines, etc.
    </p>
    <div class="gestimmo-info-actions">
      <a
        class="gestimmo-info-primary"
        href="https://www.gestimmo.swiss"
        target="_blank"
        rel="noopener"
        (click)="closeInfo()"
      >
        <em class="fal fa-sparkles"></em> Découvrez GestImmo
      </a>
      <button
        type="button"
        class="gestimmo-info-secondary"
        (click)="closeInfo()"
      >
        Continuer sur Mir
      </button>
    </div>
  </div>
</div>
}

@if (confirming) {
<div class="gestimmo-confirm-backdrop" (click)="cancelDismiss()">
  <div class="gestimmo-confirm-modal" (click)="$event.stopPropagation()">
    <p>
      <strong>Vous travaillez dans une commune ?</strong> GestImmo est
      développé par la même équipe que Mir, avec la même philosophie :
      simplifier le travail au quotidien. Il permet de de gérer
      les infrastructures, bâtiments, espaces verts, véhicules, machines, etc.
    </p>
    <div class="gestimmo-confirm-actions">
      <button
        type="button"
        class="gestimmo-confirm-secondary"
        (click)="confirmDismiss()"
      >
        Masquer quand même
      </button>
      <a
        class="gestimmo-confirm-primary"
        href="https://www.gestimmo.swiss"
        target="_blank"
        rel="noopener"
        (click)="cancelDismiss()"
      >
        <em class="fal fa-sparkles"></em> Découvrez GestImmo
      </a>
    </div>
  </div>
</div>
}
